var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.429 0H6.837a1.6 1.6 0 0 0-.979.406l-5.69 5.69a.575.575 0 0 0 0 .811l4.925 4.925a.575.575 0 0 0 .811 0l5.69-5.69A1.6 1.6 0 0 0 12 5.163V.572a.575.575 0 0 0-.574-.574ZM8.558 4.589a1.147 1.147 0 1 1 1.148-1.147 1.147 1.147 0 0 1-1.148 1.147Z",
    "data-name": "Icon metro-tag"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.9f61798ea5ea07eb92c8667185410e32.svg";
export { ForwardRef as ReactComponent };